import { Component, OnDestroy, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { lastValueFrom } from 'rxjs';

export type ExternalFileType = 'img' | 'pdf' | 'html' | 'other' | null;

export interface UrlViewDialogData {
  url: string;
  type?: ExternalFileType;
}

@Component({
  template: `
  <div class="h-full flex flex-col" style="max-height: 90vh">
    <div *ngIf="type === 'pdf' || type === 'html' || type === 'img'" class="h-full">
      <iframe [src]="safeUrl" style="width: 100%; height: 100%"></iframe>
    </div>
    <div *ngIf="type === 'other'" style="height: 100%; display: flex; justify-content: center; align-items: center;">
      <span>No viewer available for this file type</span>
    </div>
    <div *ngIf="!type" style="height: 100%; display: flex; justify-content: center; align-items: center;">
      <span>No file loaded</span>
    </div>
  </div>
  `,
  standalone: false
})
export class UrlViewDialogComponent implements OnInit, OnDestroy {

  static config = { header: 'View External Content' };
  safeUrl?: SafeResourceUrl;
  type: ExternalFileType = null;
  data: UrlViewDialogData;

  public static async openDialog(
    dialogService: DialogService,
    data?: UrlViewDialogData,
    config?: DynamicDialogConfig<UrlViewDialogData>,
  ) {
    const ref = dialogService.open(UrlViewDialogComponent, {
      closable: true,
      draggable: true,
      resizable: true,
      modal: true,
      width: '90vw',
      height: '90vh',
      focusOnShow: false,
      ...config,
      data: data,
    });
    const r = await lastValueFrom(ref.onClose);
    return r;
  }

  constructor(dialogConfig: DynamicDialogConfig, private ref: DynamicDialogRef, private readonly sanitizer: DomSanitizer) {
    this.data = dialogConfig.data;
  }

  ngOnInit(): void {
    this.type = this.data.type || this.getType(this.data.url);
    this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.data.url);
  }

  ngOnDestroy(): void {
    this.clearUrl();
  }

  private getType(url: string): ExternalFileType {
    const uobj = URL.parse(url);
    const suffix = uobj?.pathname.split('.').pop() || '';
    if (suffix == 'pdf') {
      return 'pdf';
    } else if (suffix == 'htm' || suffix == 'html') {
      return 'html';
    } else if (['jpg', 'jpeg', 'png', 'webp', 'gif'].includes(suffix)) {
      return 'img'
    } else {
      return 'other';
    }
  }

  private clearUrl() {
    this.safeUrl = undefined;
  }

  close() {
    this.clearUrl();
    this.ref.close();
  }

}
